import { render, staticRenderFns } from "./SupplierManufacturingPest.vue?vue&type=template&id=0298a076&scoped=true&"
import script from "./SupplierManufacturingPest.vue?vue&type=script&lang=js&"
export * from "./SupplierManufacturingPest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0298a076",
  null
  
)

export default component.exports